import { useEffect } from 'react';
import { PaymentType, TournamentType } from '@/types/tournament.model';
import type { WizardStepProps, PricingSlice } from '../../../engine/types';
import {
  PricingCalculatorField,
  DEFAULT_PRICING_STEP_CONFIG,
  type PricingStepConfig,
} from '../../../blocks/pricing';

export type { PricingStepConfig } from '../../../blocks/pricing';

const DEFAULT_CURRENCY = {
  isoCode: 'ARS',
  name: 'Peso Argentino',
};

const DEFAULT_CONFIG: PricingStepConfig = DEFAULT_PRICING_STEP_CONFIG;

interface PricingStepProps extends WizardStepProps<PricingSlice> {
  config?: PricingStepConfig;
}

export function PricingStep({
  data,
  updateData,
  config: userConfig,
}: PricingStepProps) {
  const config = { ...DEFAULT_CONFIG, ...userConfig };

  useEffect(() => {
    if (!data) {
      updateData({
        price: {
          id: '',
          value: 0,
          currency: config.currency ?? DEFAULT_CURRENCY,
        },
        paymentType: PaymentType.MERCADOPAGO,
        type: TournamentType.SOFT,
        isValid: false,
      });
    }
  }, [data, updateData, config.currency]);

  useEffect(() => {
    if (
      config.isBalanceRestricted &&
      data?.paymentType !== PaymentType.MERCADOPAGO
    ) {
      updateData({ paymentType: PaymentType.MERCADOPAGO });
    }
  }, [config.isBalanceRestricted, data?.paymentType, updateData]);

  if (!data) {
    return null;
  }

  return (
    <PricingCalculatorField
      price={data.price}
      onPriceChange={(price) => updateData({ price })}
      paymentType={data.paymentType}
      onPaymentTypeChange={(paymentType) => updateData({ paymentType })}
      onPriceValidationChange={(isValid) => updateData({ isValid })}
      config={config}
    />
  );
}

export default PricingStep;
